import { createTheme } from "@mui/material/styles";

const theme = createTheme({
    palette: {
        mode: "dark", // use "light" if you prefer
        primary: {
            main: "#00FFFF", // your main brand color
        },
        secondary: {
            main: "#00FF00",
        },
        background: {
            default: "lightgray", // overall background
            paper: "lightgray",   // used in drawers, cards, etc.
        },
        text: {
            primary: "#ffffff",
            secondary: "#b0bec5",
        },
        sidebar: {
            background: "#0f1e47",
            itemBgActive: "#1e2d5c",
            itemBgHover: "#263d6f",
        },
        table: {
            headerBackground: "#b6c8f0",
            footerBackground: "#ddd",
        }
    },
    typography: {
        fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        fontSize: 14,
        h1: { fontWeight: 700 },
        h2: { fontWeight: 600 },
        h3: { fontWeight: 500 },
        h4: { fontWeight: 500 },
        h5: { fontWeight: 500 },
        h6: { fontWeight: 500 },
        body1: { fontWeight: 400 },
        body2: { fontWeight: 400 },
    },
    components: {
        MuiTextField: {
            defaultProps: {
                variant: "outlined",
                InputLabelProps: { shrink: true },
            },
        },
        MuiInputBase: {
            styleOverrides: {
                input: ({ theme }) => ({
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.text.primary,
                }),
            },
        },
        MuiInputLabel: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily: theme.typography.fontFamily,
                    color: 'black', // Ensure the label color is always black
                    '&.Mui-focused': {
                        color: 'black', // Ensure the focused label color is also black
                    },
                }),
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: ({ theme }) => ({
                    fontFamily: theme.typography.fontFamily,
                    color: theme.palette.text.secondary,
                }),
            },
        },
    },
});

export default theme;